export const GENERAL_INFO = 'generalInfo';
export const FUNDINGS = 'fundings';
export const COMPETITORS = 'competitors';
export const VC_FUNDS = 'vcFunds';
export const EMPLOYEES = 'employees';
export const SALES_METRICS = 'salesMetrics';
export const FINANCIALS = 'financials';
export const REVENUE_METRICS = 'revenueMetrics';
